import React from "react";
import { HeaderButtonsPC } from "../../../Header/loader";
import { HeaderLinksPC } from "../../../Header/HeaderLinksPC";
import { LanguagesMenu } from "../../../../components/LanguageSwitcher/loader";
import {
  ControlCenterComponentType,
  ControlCenterFactory
} from "../../../../components/ControlCenter";
import { links } from "./Config.resource";
import { CrossActivity } from "../../../CrossActivity/loader";
import { HeaderRightCTA } from "../../../Header/HeaderWrapper";

const HeaderPC = () => {
  return (
    <HeaderRightCTA>
      <CrossActivity />
      <ControlCenterFactory
        componentType={ControlCenterComponentType.HeaderButton}
      />
      <LanguagesMenu />
      <HeaderLinksPC helpLink={links.help} />
      <HeaderButtonsPC />
    </HeaderRightCTA>
  );
};

export default React.memo(HeaderPC);
